import * as actionTypes from '../actions/auth/actionTypes';

const initialState = {
  token: null,
  user: null,
  loading: false,
  isProfileStatusLoading: false,
  userRole: null,
  existsByUserName : null
};

const signInStart = (state, action) => {
  return {...state, loading: true};
};
const signInSuccess = (state, action) => {
  return {...state, ...action.payload, loading: false};
};
const signInFail = (state, action) => {
  return {...state, loading: false};
};

const signOut = () => {
  return {...initialState};
};

const registerStart = (state, action) => {
  return {
    ...state,
    loading: true,
  };
};

const registerEnd = (state, action) => {
  return {
    ...state,
    loading: false,
  };
};

const existsByUserNameStart = (state,action) => {
  return{
    ...state,
  }
}

const existsByUserNameSuccess = (state,action) => {
  return{
    ...state,
    existsByUserName: action.payload

  }
}
const existsByUserNameFail =(state,action) =>{
  return{
    ...state
  }
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SIGN_IN_START:
      return signInStart(state, action);
    case actionTypes.SIGN_IN_SUCCESS:
      return signInSuccess(state, action);
    case actionTypes.SIGN_IN_FAIL:
      return signInFail(state, action);
    case actionTypes.REGISTER_START:
      return registerStart(state, action);
    case actionTypes.SIGN_OUT:
      return signOut();
    case actionTypes.REGISTER_END:
      return registerEnd(state, action);
    case actionTypes.EXISTS_BY_USERNAME_START:
      return existsByUserNameStart(state,action);
    case actionTypes.EXISTS_BY_USERNAME_SUCCESS:
      return existsByUserNameSuccess(state,action);
    case actionTypes.EXISTS_BY_USERNAME_FAIL:
      return existsByUserNameFail(state,action);
    default:
      return state;
  }
};

export default reducer;
